import { render, staticRenderFns } from "./AskTopic.vue?vue&type=template&id=0649a058&scoped=true"
import script from "./AskTopic.vue?vue&type=script&lang=js"
export * from "./AskTopic.vue?vue&type=script&lang=js"
import style0 from "./AskTopic.vue?vue&type=style&index=0&id=0649a058&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0649a058",
  null
  
)

export default component.exports